export default "__VITE_ASSET__lNLZ4qNF__"